var _circle, _path, _path2, _path3, _path4, _circle2, _circle3, _circle4, _path5, _path6, _circle5, _path7, _path8, _path9, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoOfStructures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9019 28.0945V12.8787C24.9019 12.1869 25.4626 11.6262 26.1543 11.6262C26.846 11.6262 27.4067 12.1869 27.4067 12.8787V41.1213C27.4067 41.8131 26.846 42.3738 26.1543 42.3738C25.4626 42.3738 24.9019 41.8131 24.9019 41.1213V33.7095",
    stroke: "white",
    strokeWidth: 1.25245,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6746 26.3738C15.7314 26.3738 15.7314 27.6262 18.7882 27.6262C21.845 27.6262 21.845 26.3738 24.9018 26.3738",
    stroke: "white",
    strokeWidth: 1.25245,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6746 17.0865C15.7314 17.0865 15.7314 18.339 18.7882 18.339C21.845 18.339 21.845 17.0865 24.9018 17.0865",
    stroke: "white",
    strokeWidth: 1.25245,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6746 35.661C15.7314 35.661 15.7314 36.9135 18.7882 36.9135C21.845 36.9135 21.845 35.661 24.9018 35.661",
    stroke: "white",
    strokeWidth: 1.25245,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.3645,
    cy: 20.4628,
    r: 0.626223,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8801,
    cy: 13.6047,
    r: 0.626223,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.1719,
    cy: 30.2065,
    r: 0.626223,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5371 33.532C16.2288 33.532 16.7896 32.9713 16.7896 32.2795C16.7896 31.5878 16.2288 31.0271 15.5371 31.0271C14.8454 31.0271 14.2847 31.5878 14.2847 32.2795C14.2847 32.9713 14.8454 33.532 15.5371 33.532Z",
    stroke: "white",
    strokeWidth: 1.25245,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2647 24.4561C20.9564 24.4561 21.5171 23.8953 21.5171 23.2036C21.5171 22.5119 20.9564 21.9512 20.2647 21.9512C19.5729 21.9512 19.0122 22.5119 19.0122 23.2036C19.0122 23.8953 19.5729 24.4561 20.2647 24.4561Z",
    stroke: "white",
    strokeWidth: 1.25245,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.377,
    cy: 40.1322,
    r: 0.626223,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5759 25.2977V23.978C34.5759 23.8308 34.74 23.7431 34.8624 23.8248L39.1633 26.6966C39.3797 26.841 39.3797 27.159 39.1633 27.3034L34.8624 30.1752C34.74 30.257 34.5759 30.1692 34.5759 30.022V28.883H27.4067V25.2976L34.5759 25.2977Z",
    stroke: "white",
    strokeWidth: 1.25245,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5759 15.6472V14.3275C34.5759 14.1803 34.74 14.0925 34.8624 14.1743L39.1633 17.0461C39.3797 17.1905 39.3797 17.5085 39.1633 17.6529L34.8624 20.5247C34.74 20.6065 34.5759 20.5187 34.5759 20.3715V19.2325H27.4067V15.6471L34.5759 15.6472Z",
    stroke: "white",
    strokeWidth: 1.25245,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5759 34.9483V33.6286C34.5759 33.4814 34.74 33.3937 34.8624 33.4754L39.1633 36.3472C39.3797 36.4917 39.3797 36.8096 39.1633 36.9541L34.8624 39.8259C34.74 39.9077 34.5759 39.8199 34.5759 39.6726V38.5336H27.4067V34.9483L34.5759 34.9483Z",
    stroke: "white",
    strokeWidth: 1.25245,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9019,
    cy: 30.902,
    r: 0.626223,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOfStructures);
export default __webpack_public_path__ + "static/media/NoOfStructures.8d49b6b37a201c64c276acd923ade83b.svg";
export { ForwardRef as ReactComponent };